<div class="row justify-content-center">
  <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
    <div class="card floating shadow-lg">
      <div class="card-body">
        <h3 class="card-title main-title">Forgot Password</h3>
        <div class="row">
          <div class="col">
            <div class="form-control-plaintext">
              Enter your email address to reset your password
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>E-mail</mat-label>
              <input matInput [(ngModel)]="email" type="text">
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row card-footer">
        <div class="col text-center">
          <a class="btn btn-blue" (click)="checkEmail()">Submit</a>
          <a class="btn btn-secondary" (click)="backToLogin()">Back to login</a>
        </div>
      </div>
    </div>
  </div>
</div>